import { motion } from 'framer-motion'
import styled from 'styled-components'

export const Container = styled.div<{
  ref?: any
  fullWidth?: boolean
}>`
  position: relative;
  display: inline-flex;
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'fit-content')};
`

export const Trigger = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  justify-content: space-between;
  margin: 0;
  padding: 6px 12px;
  cursor: pointer;
  transition: border-color 0.15s ease, opacity 0.15s ease;
  border: 1px solid ${({ theme }) => theme.color.base.c2};
  border-radius: 100px;
  background: ${({ theme }) => theme.color.base.c1};

  &:hover:not(:disabled) {
    border-color: ${({ theme }) => theme.color.base.c4};
  }

  &:disabled {
    cursor: default;
    opacity: 0.6;
  }
`

export const TriggerContent = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
`

export const Chevron = styled.span<{ isOpen: boolean }>`
  display: inline-flex;
  color: ${({ theme }) => theme.color.base.c6};
  transition: transform 0.2s ease;
  transform: rotate(${({ isOpen }) => (isOpen ? 180 : 0)}deg);
`

export const Menu = styled(motion.div)<{ fullWidth?: boolean }>`
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};
  z-index: 10;
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 180px;
  padding: 6px;
  border-radius: 12px;
  background: ${({ theme }) => theme.color.base.c0};
  box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.12);
`

export const OptionButton = styled(motion.button)<{
  isSelected: boolean
}>`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  margin: 0;
  padding: 8px 10px;
  border: none;
  border-radius: 8px;
  text-align: left;
  cursor: pointer;
  background: ${({ isSelected, theme }) =>
    isSelected ? theme.color.base.c1 : 'transparent'};
  transition: background 0.15s ease, opacity 0.15s ease;

  &:hover:not(:disabled) {
    background: ${({ theme }) => theme.color.base.c1};
  }

  &:disabled {
    cursor: default;
    opacity: 0.5;
  }
`

export const OptionLabel = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme }) => theme.color.base.c7};
`
